<template>
  <div class="ralSelection">
    <div class="d-none d-md-block">
      <model-list-select :list="ralListJson"
                        v-model="stringItem"
                        option-value="NiceGerman"
                        :custom-text="codeAndName"
                        name="stripColor"
                        :placeholder="$t(`endProfiles.stripColor.chooseColor`)"
                        v-on:click="registerUserInput()" v-on:keyup="registerUserInput()"
                        >
      </model-list-select>
    </div>
    <div class=" d-md-none">
      <select class="ralMobile">
        <option value="" disabled selected> {{$t(`endProfiles.stripColor.chooseColor`)}}</option>
        <option v-for="(item, index) in ralListJson" :key="index" :value="codeAndName (item)"> {{codeAndName (item)}}</option>
    </select>
    </div>
  </div>
</template>

<script>
import { ModelListSelect } from './vue-search-select-minimal-fork'

export default {
  data () {
    return {
      ralListJson: require('../configfiles/ral-list.json'),
      stringItem: ''
    }
  },
  methods: {
    codeAndName (item) {
      return `${item.RAL} - ${item.German}`
    },
    updateRalValue () {
      if ((this.$store.state.calculatorData.currentOrder.profilColor !== 'white') && (this.$store.state.calculatorData.currentOrder.profilColor !== 'alu') && (this.$store.state.calculatorData.currentOrder.profilColor !== '')) {
        this.stringItem = this.$store.state.calculatorData.currentOrder.profilColor
        this.tracking(this.$store.state.calculatorData.currentOrder.profilColor)
      }
    },
    registerUserInput: function () {
      // this line needs to track only User Input
      this.$root.$children['0'].userDidAction = true
    },
    tracking: function (value) {
      if (value !== 'on') {
        // this.$root.$children['0'].userDidAction = true
        let gtmEvent = 'JKK-Events'
        let gtmEventCategory = 'Farbauswahl Abschlussleisten'
        let gtmEventAction = 'Radio'
        let gtmEventLabel = (value === 'on') ? 'Sonder - RAL' : value
        let virtualPageURL = '/profile'
        let virtualPageTitle = 'Profile'
        if (
          (this.$root.$children['0'].userDidAction) &&
          (typeof this.$root.$children['0'].currentPage !== 'undefined') &&
          ((this.$root.$children['0'].currentPage.headline === 'profiles') || (this.$root.$children['0'].currentPage.headline === 'merchandiserView'))) {
          this.$root.$children['0'].globalGTMFkt(gtmEvent, gtmEventCategory, gtmEventAction, gtmEventLabel, '', virtualPageURL, virtualPageTitle)
        }
      }
    }
  },
  components: {
    ModelListSelect
  },
  watch: {
    stringItem: function (val, oldVal) {
      this.registerUserInput()
      const payload = {
        key: 'profilColor',
        value: val,
        validate: true
      }
      this.$store.dispatch('didInputFkt', payload)
    }
  },
  mounted: function () {
    // console.log('--- ralSelection rendert ---')
    // console.log('mounted')
    this.updateRalValue()
  }
}
</script>
